import { StoreIssueDoc } from '@gooduncles/gu-app-schema';
import { Popover } from 'antd';
import { formatDate } from 'date-fns';
import { FC } from 'react';

import classes from './TaskSpotCard.module.scss';

interface StoreIssueBadgeProps {
  issue: StoreIssueDoc;
}

const StoreIssueBadge: FC<StoreIssueBadgeProps> = ({ issue }) => {
  return (
    <Popover
      title={formatDate(issue.date, 'yyyy-MM-dd')}
      content={
        <div>
          {issue.memo && <p>{issue.memo}</p>}
          {issue.message && <p>{issue.message}</p>}
          {issue.productName && (
            <p>
              {issue.productName} {issue.volume && <span>{issue.volume}개</span>}
            </p>
          )}
        </div>
      }>
      <span className={`${classes.issue} ${issue.category ? classes[issue.category] : ''}`}>
        {issue.category}
      </span>
    </Popover>
  );
};

export default StoreIssueBadge;
